
<template>
  <div style="width: 100%">
    <div style="width: 70%;margin: auto">
      <el-steps :active="state.active" simple  :align-center="true" >
        <el-step icon="el-icon-edit" title="作品描述" description="描述将公开显示" @click="currentChange"></el-step>
        <el-step icon="el-icon-lock" title="付费内容" description="支付后可见"></el-step>
        <el-step icon="el-icon-setting" title="发布设置" description=""></el-step>
      </el-steps>
    </div>
  <div style="display: flex;justify-content:space-between;width: 70%;margin: auto">
    <el-button v-if="state.active>1" @click="pre"><i class="el-icon-back"></i>上一步 </el-button><el-button type="primary" @click="next">下一步 <i class="el-icon-right"></i> </el-button>
  </div>
    <div style="width: 70%;margin: auto">
    <el-form  :rules="rules" ref="pushdoc" label-position="left" label-width="80px" :model="formLabelAlign">
      <el-form-item v-show="state.active==1" label="标题" prop="title">
        <el-input v-model="formLabelAlign.title" placeholder="请输入作品标题"></el-input>
      </el-form-item>
      <el-form-item label="所属分类" prop="categoryId" v-show="state.active==1">
        <el-select v-model="formLabelAlign.category" placeholder="请选择分类">
          <el-option
              v-for="item in categories"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="state.active==1||state.active==2" :label="label" style="z-index: 9999" prop="publicContent">
        <wangeditor @contentChange="onChange" ref="editor"></wangeditor>
      </el-form-item>
      <el-form-item v-show="state.active==2" label="附件">
      <el-upload
          class="upload-demo"
          drag
          :action="action"
          :file-list="filelist"
          :on-success="handleAttachSuccess"
          :before-upload="beforeUpload"
          multiple>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">单文件不超过50mb</div>
      </el-upload>
      </el-form-item>
      <el-form-item v-show="state.active==3" label="定价" prop="amt">
        <el-input type="number" placeholder="请输入金额" v-model="formLabelAlign.amt">
          <template slot="prepend">¥</template>
        </el-input>
      </el-form-item>
      <el-form-item v-show="state.active==3" label="封面" prop="cover">
      <el-upload
          class="avatar-uploader"
          :action="action"
          name="file"
          :drag="true"
          :show-file-list="true"
          :on-success="handleCoverSuccess"
          :before-upload="beforeUpload"
          list-type="picture"
          :limit="1"
          :file-list="imglist"
          accept="image/png, image/jpeg"
          >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">单文件不超过10mb,最多一个</div>
      </el-upload>
      </el-form-item>
      <el-form-item v-show="state.active==3" label="是否公开" >
        <el-switch
            v-model="formLabelAlign.isOpen"
            active-color="#13ce66"
            active-value="Y"
            inactive-value="N"
            inactive-color="#ff4949">
        </el-switch>
      </el-form-item>
    </el-form>
    </div>
  </div>
</template>
<script>
import Wangeditor from "@/components/editor/wangeditor.vue";
import document from "@/view/creation/document.vue";
import {getDictList} from "@/api/system/dict";
let loading=null;
export default {
  components: {Wangeditor},
  data() {
    return {
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          {  min:1,max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        publicContent: [
          { required: true, message: '请输入公开内容', trigger: 'blur' }
        ],
        amt: [
          { required: true, message: '请输入价格', trigger: 'blur' }
        ],
        cover: [
          { required: true, message: '请上传封面', trigger: 'blur' }
        ]
      },
      action: process.env["VUE_APP_BASE_API2"]+'/system/image/upload',
      filelist:[],
      imglist:[],
      label:'公开内容',
      state: {
        title: '',
        currentDate: '2005-01-04 21:34:11',
        active: 1
      },
      abelPosition: 'right',
      formLabelAlign: {
        title: '',
        amt: '',
        cover: '',
        publicContent:"",
        privateContent:'',
        attachments:[],
        id:'',
        category:'',
        excerpt:''
      }
    };
  },
  mounted(){
    this.getCategories()
    // this.route.query.id
    this.$http2({
      url: `/klgeek/creation/${this.$route.query.id}`,
      method: 'get'
    }).then((res) => {
      console.log(this.userStore.userInfo);
      if(res.data.createBy!=this.userStore.userInfo.id){
        this.$message({
          message: '无权限',
          type: 'warning'
        });
        return;
      }
      this.formLabelAlign=res.data;
      this.changeContent();
      if(this.formLabelAlign.attachments){
        this.filelist=this.formLabelAlign.attachments;
      }
      this.imglist.push({name:this.formLabelAlign.cover,url:this.formLabelAlign.cover})
    })
  },
  beforeDestroy() {
    console.log("销毁")
    this.$refs.editor.getInstance().destroy() // 组件销毁时，及时销毁编辑器
  },
  watch: {
    state(newVal, oldVal) {
      console.log(`Message changed from "${oldVal}" to "${newVal}"`);
    }
  },
  methods: {
    async getCategories() {
      try {
        const res = await getDictList('creation_category')
        // 处理返回的分类数据
        this.categories = res.rows.map(item => ({
          dictValue: item.dictValue,
          dictLabel: item.dictLabel
        }))
      } catch (error) {
        console.error('获取分类列表失败:', error)
        this.$message.error('获取分类列表失败')
      }
    },
    beforeUpload(){
       loading = this.$loading({
        lock: true,
        text: '上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    handleAttachSuccess(response, file, fileList){
      file.url=response.data.originUrl;
      console.log(file,fileList)
      this.filelist=fileList;
      loading.close();
    },
    handleCoverSuccess(response, file, fileList){
      this.formLabelAlign.cover=response.data.originUrl
      console.log(response,fileList)
      loading.close();
    },
    onChange(editor){
      if(this.state.active==1){
        this.formLabelAlign.publicContent=editor.getHtml();
        this.formLabelAlign.excerpt=editor.getText()
      }else if(this.state.active==2){
        this.formLabelAlign.privateContent=editor.getHtml();
      }
      console.log('content', editor.getHtml());
    },
    currentChange(num) {
      console.log(num);
    },
    next(){
      this.state.active++;
      this.changeContent();
      if(this.state.active>3){
        this.state.active=3;
        this.formLabelAlign.attachments=[]
        if(this.filelist){
          this.filelist.forEach((element, index) => {
            this.formLabelAlign.attachments.push({
              name:element.name,
              url:element.url
            })

          });
        }
        console.log(this.formLabelAlign)
        this.$refs['pushdoc'].validate((valid) => {
          console.log(valid)
          if (valid) {
            this.$http2({
              url: `/klgeek/creation`,
              method: 'put',
              data:this.formLabelAlign
            }).then((res) => {
              this.$message({
                message: '更新成功',
                type: 'success'
              });
              this.$router.push("/home/creation/document");
            })
          } else {
            this.$message({
              message: '请检查必输项',
              type: 'warning'
            });
            return false;
          }
        });
      }
    },
    pre(){
      this.state.active--;
     this.changeContent();
      if(this.state.active<=1)
        this.state.active=1
    },
    changeContent(){
      if(this.state.active==1){
        this.label="公开内容";
        this.$refs.editor.getInstance().setHtml(this.formLabelAlign.publicContent)
      }else if(this.state.active==2){
        this.$refs.editor.getInstance().setHtml(this.formLabelAlign.privateContent)
        this.label="付费内容";
      }
    }
  },
}
</script>

<style scoped lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  max-width: 100%;
  display: block;
}
</style>